// extracted by mini-css-extract-plugin
module.exports = {"title":"StatisticsHeader_title_1a0FD","label":"StatisticsHeader_label_1XBDB","cell":"StatisticsHeader_cell_1z6Rs","row":"StatisticsHeader_row_1zB79"};